var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
document.addEventListener("DOMContentLoaded", () => {
  const censusCheckButton = document.querySelector("[data-census-check-button]");
  if (!censusCheckButton) {
    return;
  }
  const url = censusCheckButton.dataset.censusCheckUrl;
  if (!url) {
    return;
  }
  const explanation = document.querySelector("[data-census-check-explanation]");
  const toggleVisibility = (show) => {
    censusCheckButton.classList.toggle("hidden", !show);
    if (explanation) {
      explanation.classList.toggle("hidden", !show);
    }
  };
  const updateVisibility = () => __async(null, null, function* () {
    try {
      const response = yield fetch(url, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (!response.ok) {
        return;
      }
      const data = yield response.json();
      const shouldShow = data.allow_census_check_before_start && data.census_ready && data.scheduled;
      toggleVisibility(shouldShow);
      if (data.scheduled) {
        setTimeout(updateVisibility, 4e3);
      }
    } catch (error) {
      setTimeout(updateVisibility, 4e3);
    }
  });
  updateVisibility();
});
